// @ts-ignore
import ru from 'hyphenated-ru';
// @ts-ignore
import { hyphenated } from 'hyphenated';

export const hyphenatedText = (text: string): string => {
  return hyphenated(text, {language: ru})
}
